import React from 'react'
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";

const BigCard = ({img,h1,h2,p}) => {
  return (
    <div>
    
    <div className="homeslider_container relative w-full overflow-x-hidden h-[350px]">
      
      <div className="homeslider w-full h-full flex">
            <div className="slideritem relative w-full h-full flex-shrink-0 overflow-y-hidden">
            <img
                src={img}
                className="w-full relative object-fit"
                alt=""
            />
            <div className="absolute z-10 flex flex-col top-[5%] left-[8%] custom:top-[15%] md:text-left md:top-[25%] md:left-[8%] space-y-4">
                
                <h1 className='hidden md:block text-white'>{h1}</h1>
                <div className=" lg:text-5xl font-bold text-center text-4xl md:text-left text-white">
                  {h2}
                </div>
                <div className="text-[15px] md:text-left hidden md:block lg:text-[20px] text-white mt-2">
                  {p}
                </div>
                <div className='text-center md:text-left'>
                <button className='border text-sm  p-1 md:p-2 md:px-6 hover:bg-green-600 text-white'>Learn More</button>
                </div>
       
                
            </div>
            </div>
      </div>
     
    </div>




    </div>
  )
}

export default BigCard
